import React, {forwardRef} from 'react';
import {motion} from 'framer-motion';

import {Box} from '@spothero/ui';

const FramerMotionBox = motion(Box);

const MotionBox = forwardRef((props, ref) => {
    return <FramerMotionBox {...props} ref={ref} />;
});

export default MotionBox;
